import React from "react";

const cardData = [
  {
    image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1744240954/image_xiaii1.png",
    date: "March 03, 2025",
    title: "Disease monitoring through SMART management",
    description: "Scanning livestock diseases, Diagnosis, treatment and management",
  },
  {
    image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1744240923/image-1_i2fszj.png",
    date: "February 07, 2025",
    title: "Disease monitoring through SMART management",
    description: "Scanning livestock diseases, Diagnosis, treatment and management",
  },
  {
    image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1744240924/image-2_cgzldp.png",
    date: "January 15, 2025",
    title: "Automated environmental control systems",
    description: "Sensor-based monitoring to optimize the living conditions of chickens and improve overall farm efficiency.",
  },
];

const CardSection = () => {
  return (
    <section className="relative bg-white md:px-20 px-4">
      <div className="absolute md:bottom-0 md:left-0 bottom-0 left-0 w-full h-[130px] md:h-[380px] bg-[#152C24] z-0"></div>

      <h2 className="text-[8px] md:text-[48px] font-bold text-black leading-tight md:pt-14 pt-5">
        Stay informed with insights and innovations in Agriculture
      </h2>

      <div className="flex flex-row items-end  md:space-x-5 md:mt-3 mt-2 md:mb-6 mb-2 ">
        <p className="text-[7px] md:text-[18px] text-black flex-1 md:flex hidden leading-tight">
          Smart farming refers to the use of advanced technology and data-driven solutions to optimize agricultural practices. It aims to improve the efficiency, productivity, and sustainability of farming by integrating modern technologies like sensors, data analytics, automation, and the Internet of Things (IoT)
        </p>
        <p className="text-[7px] md:text-[18px] text-black md:hidden flex leading-tight">
          Smart farming refers to the use of advanced technology and data-driven solutions to optimize agricultural practices.
        </p>

        <a href="/innovationmain">
        <img src="https://res.cloudinary.com/dzngpgki4/image/upload/v1749379209/Expand_right_2_stxds0.png" alt='kin' className='md:w-[34px] md:h-[34px] h-[10px] w-[10px]'/> 

        </a>
      </div>

      <div className="grid grid-cols-3 md:grid-cols-3 md:gap-6 gap-2">
        {cardData.map((card, index) => (
          <div
            key={index}
            className="relative w-full max-w-full md:max-w-[500px] rounded-md"
          >
            {/* Image */}
            <img
              src={card.image}
              alt={`Card ${index + 1}`}
              className="w-full h-auto object-cover rounded-md"
            />

            {/* Top-left Tag */}
            <div className="absolute md:top-4 md:left-2 top-1 left-1 w-[80px] md:w-[200px] h-[20px] md:h-[37px] flex items-center justify-center">
              {/* Background layer with blend mode */}
              <div className="absolute inset-0 bg-[#093816] opacity-90 mix-blend-multiply rounded-md"></div>

              {/* Text layer stays normal */}
              <p className="relative text-white text-[6px] md:text-[14px] font-normal z-10">
                Technology & Innovation
              </p>
            </div>



            {/* Text Content */}
            <div className="px-1 md:px-2 md:mt-4 mt-2">
              <p className="text-[5px] md:text-[16px] text-white font-normal mb-1  smd:-mb-1">
                {card.date}
              </p>
              <p className="text-[7px] md:text-[24px] text-white font-bold md:mb-6 mb-1 leading-snug" style={{ lineHeight: '1.10' }}>
                {card.title}
              </p>
              <p className="text-[6px] md:text-[16px] text-white font-light mb-2  " style={{ lineHeight: '1.10' }}>
                {card.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default CardSection;
